// extracted by mini-css-extract-plugin
export default {"container":"NW-z","title":"OW-z","link":"PW-z"};